export default __webpack_public_path__ + "static/media/cyaf-logo.44c5cf88.png";